angular.module('charts')
  .directive("frequencyGraph", function() {
    return {
      restrict: "E",
      scope: {
        frequencyData: '=',
        activeMetric: '@',
        defaultMetric: '@',
        title: '@',
        yLabelFilter: '@'
      },
      templateUrl: '/resources/charts/partials/frequency-graph.html',
      controller: ['$scope', '$state', '$timeout', 'highchartConfigs', function($scope, $state, $timeout, $highchartConfigs) {

        var getTooltip = function(data) {
          var label = $scope.yLabelFilter;
          label = data.y !== 1 ? label : label.substring(0, label.length - 1);
          if(data.y !== 0) {
            return '<span style="text-transform: capitalize; font-weight: bold;">' + data.y + '</span> <span> ' + label + '</span></span>';
          } else  {
            return false;
          }
        };

        $scope.graphTitles = {
          status: 'Status',
          average_weekly_session_time: 'Average Minutes of Usage per Week',
          percent_usage_extended_hours: 'Percentage of Usage in Extended Hours',
          average_weekly_lessons: 'Average Lessons Completed per Week',
          percent_growth: 'Growth',
          standards_growth: 'Standards Met',
          standards_partial_growth: 'Standards Progressed In',
          percent_active_students: 'Average Daily % Active Students',
          count_lessons_completed: 'Total Lessons',
          total_session_time: 'Total Hours'
        };

        /* Watch for changes on scope object - since it is databound
         * it will react to any changes to the item.usageGraph object.
         * Note - make sure when you update the usageGraph object that
         * you use $scope.$apply() to update bindings. Or in this case
         * $timeout which clears the callstack and does a $scope.$apply();
         */
        $scope.$watchCollection('frequencyData', function(frequencyData) {
          $timeout(function() {
            if (frequencyData) {
              $scope.drawGraph();
            } else {
              $scope.showGraph = false;
            }
          }, 0);
        });

        $scope.$on('updateSortableTable', function(e, activeMetric) {
          if (angular.equals($scope.activeMetric, activeMetric)) {
            return;
          }
          $scope.activeMetric = activeMetric;
          $scope.drawGraph();
        });

        $scope.drawGraph = function() {
          if (!$scope.activeMetric || !$scope.frequencyData) {
            return;
          }
          $scope.showGraph = false;

          var metricData = $scope.frequencyData[$scope.activeMetric];
          var currentMetric = $scope.activeMetric;
          if (!metricData) {
            metricData = $scope.frequencyData[$scope.defaultMetric];
            currentMetric = $scope.defaultMetric;
          }

          $scope.title = $scope.graphTitles[currentMetric];

          var labels = metricData.labels;

          var values = _.map(metricData.values, function(value) {
            if (_.isObject(value)) {
              return value;
            }
            return {
              y: value,
              color: '#CECBCD'
            };
          });

          $scope.chartConfig = {
            chart: {
              type: "column",
              backgroundColor: 'transparent',
              height: 260,
            },
            title: $highchartConfigs.title,
            plotOptions: $highchartConfigs.plotOptions,
            legend: {
              enabled: false,
            },
            tooltip: {
              formatter: function () {
                return getTooltip(this);
              },
              style: {
                textAlign: 'right'
              },
              shared: true
            },
            credits: {
              enabled: false
            },
            loading: false,
            xAxis: {
              categories: labels,
              tickColor: 'transparent',
              labels: {
                style: $highchartConfigs.labelStyle
              }
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: ''
              },
              tickAmount: 3,
              labels: {
                formatter: $highchartConfigs.getYAxisLabelFormatter(this, $scope.yLabelFilter),
                style: $highchartConfigs.labelStyle
              },
              stackLabels: $highchartConfigs.getYAxisStackLabels()
            },
            series: [{
              data: values,
              showInLegend: false
            }]
          };

          $scope.showGraph = true;
        };

      }]
    };
  });
